import { EditOutlined } from '@ant-design/icons'
import { Input, Tooltip } from 'antd'
import React from 'react'

const DEFAULT_TOOLTIP = 'Click to edit. Enter to save, Esc to cancel.'

const InlineEditableCell = ({
  isActive,
  displayValue,
  value,
  error,
  onStartEdit,
  onChange,
  onCommit,
  onKeyDown,
  inputMode = 'text',
  placeholder = '',
  ariaLabel = 'Edit value, Enter to save, Escape to cancel',
  tooltipTitle = DEFAULT_TOOLTIP,
}) => {
  if (isActive) {
    return (
      <div className='gp-inline-edit-cell'>
        <Input
          autoFocus
          size='small'
          className='gp-inline-edit-input'
          inputMode={inputMode}
          autoComplete='off'
          placeholder={placeholder}
          aria-label={ariaLabel}
          value={value}
          onChange={event => onChange(event.target.value)}
          onPressEnter={onCommit}
          onBlur={onCommit}
          onKeyDown={onKeyDown}
        />
        {error && (
          <div className='gp-inline-edit-error' role='alert'>
            {error}
          </div>
        )}
      </div>
    )
  }

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.4}>
      <span
        role='button'
        tabIndex={0}
        className='gp-inline-edit-trigger'
        onClick={onStartEdit}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            onStartEdit()
          }
        }}
      >
        <span className='gp-inline-edit-value'>{displayValue}</span>
        <EditOutlined className='gp-inline-edit-icon' aria-hidden />
      </span>
    </Tooltip>
  )
}

export default InlineEditableCell
